var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderCreditor',{attrs:{"header":"เจ้าหนี้","img_header":_vm.header_image,"link_back":"creditor/all"}}),_c('MenuCreditor'),_c('ReportCreditorList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }